import { IPageData, IPageProps } from '../../../interfaces/page-data';
import { useEffect, useRef, useState } from 'react';
import { IPrint } from '../../../interfaces/IPrintData';
import {
  Button,
  Col,
  Form,
  Image,
  Modal,
  Pagination,
  Popconfirm,
  Row,
  Select,
  SelectProps,
  Space,
  Tooltip,
  Upload,
} from 'antd';
import {
  DeleteOutlined,
  DownloadOutlined,
  EyeOutlined,
  InboxOutlined,
  PrinterOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import HTTPService from '../../../utils/makerequest';
import { Toast } from 'primereact/toast';
import { ITemplatesName } from '../../../interfaces/ITemplateName';
import { ICompany } from '../../../interfaces/ICompany';
import { StateLoader } from '../../../redux/StateLoader';
import { IAuthentication, UserRole } from '../../../interfaces/authentication';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import { IPrinterData } from '../../../interfaces/IPrinterData';
import moment from 'moment';
import MUIDatagrid, { IMUIDataGridColumns } from '../../../AltisComponent/MUIDataGrid';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import Dropdown from '../../../AltisComponent/Dropdown';

const PrintsJobsExcel: React.FunctionComponent<IPageProps> = (props) => {
  const { onSetPage } = props;
  const [printList, setPrintList] = useState<IPrint>({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisibleDetails, setIsModalVisibleDetails] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [selectTemplate, setSelectTemplate] = useState<ITemplatesName[]>([]);
  const [companyData, setCompanyData] = useState<ICompany[]>();
  const [selectPrinter, setSelectPrinter] = useState<IPrinterData[]>([]);
  const [isModalImage, setIsModalImage] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const loader = new StateLoader();
  const user: IAuthentication = loader.loadAuthState();
  const imagesPerPage = 1
  const [currentPage, setCurrentPage] = useState(1);
  const { t } = useTranslation();
  const [modalData, setModalData] = useState('');
  const dataGridRef = useRef<any>(null);
  const toast = useRef<any>(null);

  const showModal = () => {
    setIsModalVisible(true);
    fetchData();
    if (user?.role !== UserRole.AltisAdmin) {
      AllTemplateName(user?.companyId);
      AllPrinterName(user?.companyId);
    }
  };

  const AllTemplateName = (values) => {
    let companyIdToUse;
    if (user?.role === UserRole.AltisAdmin) {
      companyIdToUse = values;
    } else {
      companyIdToUse = user?.companyId;
    }
    HTTPService.GET(`/Template/allTemplateName?companyId=${companyIdToUse}`)
      .then((response) => {
        if (!response.data) {
          return;
        }
        let tmp: ITemplatesName[] = response.data;
        tmp.map((elem, index) => {
          elem.key = index;
        });
        setSelectTemplate(tmp);
      })
      .catch((error) => {
        console.error('Grup adları çekme hatası:', error);
      });
  };

  const AllPrinterName = (values) => {
    let companyIdToUse;
    if (user?.role === UserRole.AltisAdmin) {
      companyIdToUse = values;
    } else {
      companyIdToUse = user?.companyId;
    }
    HTTPService.GET(`/Printer/allPrinterName?companyId=${companyIdToUse}`)
      .then((response) => {
        if (!response.data) {
          return;
        }
        let tmp: IPrinterData[] = response.data;
        setSelectPrinter(tmp);
      })
      .catch((error) => {
        console.error('Grup adları çekme hatası:', error);
      });
  };

  const fetchData = async () => {
    const result = await HTTPService.GETCompanyNames();
    setCompanyData(result);
  };

  const handleUpload = (values) => {
    try {
      const formData = new FormData();
      formData.append('file', values.inputValue.file);
      if (user.role === UserRole.AltisAdmin) {
        formData.append('companyId', values.selectedCompany);
      } else {
        formData.append('companyId', user.companyId.toString());
      }

      formData.append('templateId', values.selectUpload);
      formData.append('printerId', values.selectPrinter);

      HTTPService.POST(`/PrintJob/PrintsJobsUpload`, formData).then((response) => {
        if (response.status === 200) {
          toast.current?.show({ severity: 'success', summary: t('successful'), detail: t(response.data), life: 3000 });
          setIsModalVisible(false);
          dataGridRef.current.GetAllData()
          //window.location.reload();
        } else {
          toast.current?.show({ severity: 'error', summary: t('mistake'), detail: t(response.data), life: 3000 });
        }
      });
    } catch (error) {
      console.error('Upload error:', error);
    }
  };

  const handleDownload = () => {
    HTTPService.GETBlob(`/Template/PrintJobDownload`)
      .then((response) => {
        if (!response) {
          return;
        }
        else if (response.status === 452) {
          toast.current?.show({ severity: 'error', summary: t('mistake'), detail: t('licenceExpiredDate'), life: 3000 });
        }
        else if (response.status === 453) {
          toast.current?.show({ severity: 'error', summary: t('mistake'), detail: t('licenceNotfound'), life: 3000 });
        }
        return response;
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'template.xlsx');
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.error('API çağrısında bir hata oluştu:', error);
      });
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisibleDetails(false)
  };

  const handleCancelUpload = () => {
    setIsModalVisible(false);
  };

  const uploadProps = {
    onRemove: (file) => {
      setFileList((prevFileList) => {
        const index = prevFileList.indexOf(file);
        const newFileList = prevFileList.slice();
        newFileList.splice(index, 1);
        return newFileList;
      });
    },
    beforeUpload: (file) => {
      setFileList([file]);
      return false;
    },
    fileList,
    multiple: false,
    accept: '.xlsx,.xls',
  };

  const pageData: IPageData = {
    title: t('prints_jobs_excel'),
    loaded: true,
  };

  useEffect(() => {
    onSetPage(pageData);
    dataGridRef.current.GetAllData();
  }, []);

  const TagFilter = (e?) => {
    const filters = e?.filters;

    if (filters?.printederrorDate && Array.isArray(filters.printederrorDate)) {
      const [startDate, endDate] = filters.printederrorDate;
      filters.printDate_Start = startDate;
      filters.printDate_Finish = endDate;
      delete filters.printederrorDate;
    }

    var body = {
      sortColumn: e?.sortField,
      sortOrder: e?.sortOrder || 'asc',
      pageSize: e?.pageSize,
      page: e?.page,
      isExcel: true,
      ...filters,
    };

    HTTPService.POST(`/PrintJob/filters`, body).then((response) => {
      if (!response.data) {
        return;
      }
      if (response.status == 200) {
        setPrintList(response.data);
      } else {
        toast.current?.show({ severity: 'error', summary: t('mistake'), detail: t(response.data), life: 3000 });
      }
    });
  };

  const DeletePrintsJobs = (id) => {
    HTTPService.DELETE(`/PrintJob/deletePrintJob?Id=${id}`).then((response) => {
      if (response.status === 200) {
        toast.current?.show({ severity: 'success', summary: t('successful'), detail: t(response.data), life: 3000 });
        dataGridRef.current.GetAllData();
        //window.location.reload();
      } else {
        toast.current?.show({ severity: 'error', summary: t('mistake'), detail: t(response.data), life: 3000 });
      }
    });
  };

  const ImagePriview = (id) => {
    HTTPService.POST(`/PrintJob/Preview?printJobId=${id}&type=${"image"}`, '')
      .then((response) => {
        if (response.status === 200) {
          const tmp = response.data;
          setImageSrc(tmp);
          setIsModalImage(true);
        }
        else {
          toast.current?.show({ severity: 'error', summary: t('mistake'), detail: t(response.data), life: 3000 });
        }
      })
      .catch((error) => {
        console.error('There was an error fetching the image!', error);
      });
  };

  const tagDataColumns: IMUIDataGridColumns[] = [
    ...(user.role !== UserRole.Admin ? [{
      title: t('Company Name'),
      key: 'companyName',
      isSorting: true,
      placeHolder: t('Company Name'),
    }] : []),
    {
      title: t('template_name'),
      key: 'templateName',
      isSorting: true,
      placeHolder: t('template_name'),
      align: 'center',
      headerAlign: 'center',
    },
    {
      title: t('barcode'),
      key: 'barcode',
      placeHolder: t('barcode'),
      align: 'center',
      headerAlign: 'center',
      render: (order, record) => {
        const barcodes = record.barcode ? record.barcode.split(',') : [];
        if (barcodes.length > 1) {
          return (
            <div style={{ maxWidth: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {barcodes[0]}...
            </div>
          );
        }
        return barcodes;
      },
    },
    {
      title: t('printed_error_date'),
      key: 'printederrorDate',
      align: 'center',
      headerAlign: 'center',
      placeHolder: t('printed_error_date'),
      render: (text) => moment(text).format('DD-MM-YYYY HH:mm'),
    },
    {
      title: t('Printer Name'),
      key: 'printerName',
      align: 'center',
      headerAlign: 'center',
      placeHolder: t('Printer Name'),
      render: (order, record) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
          <Button size='small' icon={<EyeOutlined />} style={{ display: user.role === UserRole.Sayman ? 'none' : 'block' }} onClick={() => {
            setModalData(record.printJobDetails);
            setIsModalVisibleDetails(true);
          }}
          >
            {record.printerName}
          </Button>
        </div>
      ),
    },
    {
      title: t('operations'),
      key: 'operations',
      hideColumnMenu: true,
      align: 'center',
      headerAlign: 'center',
      placeHolder: t('operations'),
      render: (order, record) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '8px' }}>
          <Space size={4}>
            <Popconfirm
              title={t('are_you_sure_printJob')}
              onConfirm={() => DeletePrintsJobs(record.printJobId)}
              okText={t('yes')}
              cancelText={t('no')}
            >
              <Tooltip title={t('delete')}>

                <Button size='small' icon={<DeleteOutlined />} style={{ width: '60px', borderRadius: '70px' }} onClick={(e) => e.stopPropagation()}>

                </Button>
              </Tooltip>

            </Popconfirm>
            <Tooltip title={t('preview')}>
              <Button
                size='small'
                icon={<EyeOutlined />}
                style={{ width: '60px', borderRadius: '70px' }}
                onClick={() => {
                  ImagePriview(record.printJobId);
                }}>
              </Button>

            </Tooltip>

            {!record.jobStatus && (
              <Tooltip title={t('Reprint')}>
                <Button
                  size='small'
                  icon={<PrinterOutlined />}
                  style={{ width: '60px', borderRadius: '70px' }}
                  onClick={() => {
                    PrintData(record.printJobId)
                  }}>
                </Button>

              </Tooltip>

            )}
          </Space>
        </div>
      ),
    },
  ];

  const paginatedImages = () => {
    const startIndex = (currentPage - 1) * imagesPerPage;
    const endIndex = startIndex + imagesPerPage;
    return imageSrc?.labels?.slice(startIndex, endIndex) || [];
  };

  const totalPages = Math.ceil((imageSrc?.labels?.length || 0) / imagesPerPage);

  const generatePagination = () => {
    const pages = [];
    const showPages = 3;

    if (totalPages <= showPages * 2 + 1) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      for (let i = 1; i <= showPages; i++) {
        pages.push(i);
      }
      if (currentPage > showPages + 2) {
        pages.push('...');
      }
      const startPage = Math.max(1, totalPages - showPages + 1);
      for (let i = startPage; i <= totalPages; i++) {
        pages.push(i);
      }
    }

    return pages;
  };


  const PrintData = (id: number) => {
    HTTPService.POST(`/PrintJob/Reprint?printJobId=${id}`, "").then((response) => {
      if (response.status === 200) {
        toast.current?.show({ severity: 'success', summary: t('successful'), detail: t(response.data), life: 3000 });
        window.location.reload();
      } else {
        toast.current?.show({ severity: 'error', summary: t('mistake'), detail: t(response.data), life: 3000 });
      }

    }).catch((response) => {

      console.error(response);
    })
  };

  const handleImage = () => {
    setIsModalImage(false);
    setImageSrc('');
  };

  const handleCompanyChange = (value) => {
    AllTemplateName(value);
    AllPrinterName(value);
  };

  return (
    <>
      <Toast ref={toast} />
      <div className='row'>
        <div className='col-md-4 mb-3' style={{ display: user.role === UserRole.Sayman ? 'none' : 'block' }}>
          <Tooltip title={t('upload_labels')}>
            <Button
              type="primary"
              shape="round"
              style={{
                width: 75,
                height: 75,
                backgroundColor: 'transparent',
                color: '#1890ff',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                marginLeft: '10px',
                padding: 0,
                border: 'none',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                e.currentTarget.style.color = '#40a9ff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.color = '#1890ff';
              }}
              size="middle"
              onClick={showModal}
            >
              <InsertDriveFileIcon style={{ fontSize: 24 }} />
              <span style={{ fontSize: '12px', marginTop: '4px' }}>{t('upload_labels')}</span>
            </Button>
          </Tooltip>
        </div>
      </div>

      <Modal
        title={t('upload_excel_file')}
        visible={isModalVisible}
        onCancel={handleCancelUpload}
        width={800}
        footer={null}
      >
        <div style={{ padding: '20px' }}>
          <Form onFinish={handleUpload}>
            <div style={{ height: 'auto', overflowY: 'auto', marginTop: '10px' }}>
              <Form.Item name='inputValue'>
                <Upload.Dragger {...uploadProps}>
                  <p className='ant-upload-drag-icon'>
                    <InboxOutlined />
                  </p>
                  <p className='ant-upload-text'>
                    {t('click_or_drag_file')}
                  </p>
                  <p className='ant-upload-hint'>
                    {t('support_single_upload')}
                  </p>
                </Upload.Dragger>
              </Form.Item>
            </div>

            <Row gutter={16}>
              <Col xs={24} sm={24} md={24} lg={24}>
                {user?.role === UserRole.AltisAdmin ? (
                  <Form.Item
                    name='selectedCompany'
                    label={t('Select company')}
                    wrapperCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: t('please_select_company'),
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder={t('select_company')}
                      style={{ width: '100%', marginBottom: '6px' }} // Consistent width
                      onChange={handleCompanyChange}
                    >
                      {companyData?.map((company) => (
                        <Select.Option key={company.companyId} value={company.companyId}>
                          {company.companyName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                ) : null}
              </Col>

              <Col span={24}>
                <Form.Item
                  name='selectUpload'
                  label={t('select_template')}
                  wrapperCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: t('please_select_template'),
                    },
                  ]}>
                  <Dropdown
                    name="selectUpload"
                    label={t('select_template')}
                    rules={[{ required: true, message: t('please_select_template') }]}
                    placeholder={t('please_select_template')}
                    dataSource={selectTemplate || []}
                    labelKey="templateName"
                    valueKey="templateId"
                    style={{ width: '100%', marginRight: 10 }}
                  />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  name='selectPrinter'
                  label={t('Select Printer')}
                  wrapperCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: t('please_select_printer'),
                    },
                  ]}>
                  <Dropdown
                    name="selectPrinter"
                    label={t('Select Printer')}
                    rules={[{ required: true, message: t('please_select_printer') }]}
                    placeholder={t('please_select_printer')}
                    dataSource={selectPrinter || []}
                    labelKey="printerName"
                    valueKey="printerId"
                    style={{ width: '100%', marginBottom: 6 }}
                  />
                </Form.Item>

              </Col>

              <Col xs={24} sm={24} md={24} lg={24}>
                <Row gutter={16} justify="end">
                  <Col xs={24} sm={12} md={8} lg={8}>
                    <Form.Item style={{ textAlign: 'right', marginTop: '20px' }}>
                      <Button
                        key='upload'
                        type='primary'
                        onClick={handleCancelUpload}
                        icon={<UploadOutlined />}
                        size='middle'
                        htmlType='submit'
                        style={{ width: '100%' }} // Ensure full width on smaller screens
                      >
                        {t('excel_file_upload')}
                      </Button>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={8}>
                    <Form.Item style={{ textAlign: 'right', marginTop: '20px' }}>
                      <Button
                        key='download'
                        type='primary'
                        onClick={handleDownload}
                        icon={<DownloadOutlined />}
                        size='middle'
                        htmlType='button'
                        style={{ width: '100%' }} // Ensure full width on smaller screens
                      >
                        {t('excel_file_download')}
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>


      <MUIDatagrid
        ref={dataGridRef}
        data={printList?.data}
        total={printList?.count}
        columns={tagDataColumns}
        filterMode='server'
        onChange={TagFilter}
      />

      <Modal title={t('image_preview')} visible={isModalImage} onCancel={handleImage} footer={null}>
        {paginatedImages().length > 0 && (
          <Image
            src={`data:image/png;base64,${paginatedImages()[0].imageBase64}`}
            style={{ width: 'auto', height: 'auto' }}
            alt='Preview'
          />
        )}
        {totalPages > 1 && (
          <Pagination
            current={currentPage}
            pageSize={imagesPerPage}
            total={imageSrc?.labels?.length}
            onChange={page => setCurrentPage(page)}
            style={{ textAlign: 'center', marginTop: '16px' }}
            itemRender={(page, type, originalElement) => {
              if (type === 'page') {
                const pages = generatePagination();
                if (pages.includes(page) || page.toString() === '...') {
                  return <span style={{ padding: '0 8px', cursor: 'pointer', fontWeight: currentPage === page ? 'bold' : 'normal' }}>{page}</span>;
                }
                return originalElement;
              }
              return originalElement;
            }}
          />
        )}
      </Modal>

      <Modal
        title={<span style={{ color: 'red' }}>{t('details')}</span>}
        visible={isModalVisibleDetails}
        bodyStyle={{ width: 510, height: 350, overflowY: 'auto' }} // Kaydırma çubuğu için ekleme
        footer={null}
        onCancel={handleCancel}
      >
        <div>
          {modalData ? modalData.split(',').map((item, index) => (
            <p key={index} style={{ margin: 0 }}>
              {item.trim()}
            </p>
          )) : (
            <p>{t('noDetails')}</p> // Ya da başka bir varsayılan mesaj
          )}
        </div>
      </Modal>
    </>
  );
};

export default PrintsJobsExcel;
